import { useContext } from 'react'
import { useSelector } from 'react-redux'

import {
  useForm, useLatestEntity, useThunkDispatch,
} from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import defaultState, { requiredFields } from '@models/customFieldSet'

import * as customFieldSetActions from '@redux/modules/customFieldSet'

const createCustomFieldSet = (customFieldSet, dispatch) => {
  const { createCustomFieldSet: createFn } = customFieldSetActions
  return dispatch(createFn(customFieldSet))
}

const addCustomFieldSet = (customFieldSet, showCreateOrEditCustomFieldSetModal) => (
  new Promise((resolve, reject) => {
    if (showCreateOrEditCustomFieldSetModal){
      const payload = {
        customFieldSet,
      }

      showCreateOrEditCustomFieldSetModal(payload)

      resolve({ success: true, result: payload })
    }

    reject(new Error('showCreateOrEditCustomFieldSetModal not defined in PageContext callbacks'))
  })
)

export function useCustomFieldSetForm(customFieldSet = {}, options = {}){
  const { validateOn } = options

  const customFieldSetForm = useForm(
    defaultState,
    { entity: customFieldSet, requiredFields, validateOn },
    [customFieldSet.id, customFieldSet.cache_key],
  )

  return {
    ...customFieldSetForm,
  }
}

function useCustomFieldSet(initEntity){
  const { entity: customFieldSet } = useLatestEntity(initEntity, 'publicationCompatiblePaginations')

  const dispatch = useThunkDispatch()

  const { callbacks } = useContext(PageContext)
  const { showCreateOrEditCustomFieldSetModal } = callbacks || {}

  const { creating, updating } = useSelector(reduxState => reduxState.customFieldSets)

  return {
    callbacks: {
      addCustomFieldSet: () => addCustomFieldSet(customFieldSet, showCreateOrEditCustomFieldSetModal),
      createCustomFieldSet: params => createCustomFieldSet(params, dispatch),
    },
    creating,
    customFieldSet,
    updating,
  }
}

export default useCustomFieldSet
